/** English text for the install guide (/install). Each value is also its translation key. */
export const I = {
  p1t: 'Opens like an app',
  p1: 'Full screen, with its own icon on your home screen, dock or taskbar. No address bar, no tabs.',
  p2t: 'One tap to your account',
  p2: 'Your orders, login details, licence keys, renewals and support tickets are always one tap away.',
  p3t: 'No app store needed',
  p3: 'Nothing to download from a store. It takes almost no space and updates itself.',

  lIos: 'iPhone & iPad',
  lDesk: 'Windows & Chromebook',
  bDesk: 'Chrome or Edge',
  bMac: 'Safari or Chrome',

  i1t: 'Open this page in Safari',
  i1: 'Opened it from Instagram, Facebook or a chat app? Tap the ••• menu and choose Open in Safari (or Open in browser) first.',
  i2t: 'Tap the Share button',
  i2: 'The square with an arrow pointing up. It sits at the bottom of the screen on iPhone and at the top on iPad.',
  i3t: 'Tap Add to Home Screen',
  i3: 'Scroll down the list to find it. If it is not there, tap Edit Actions at the bottom and add it.',
  i4t: 'Tap Add',
  i4: 'Leave Open as Web App switched on if you see it. Ghost Cable now sits on your home screen with your other apps.',
  iTip: 'Chrome on iPhone works too: tap the Share button at the right of the address bar, then Add to Home Screen.',

  a1t: 'Open this page in Chrome',
  a1: 'Opened it inside another app? Tap the ⋮ menu and choose Open in Chrome first.',
  a2t: 'Tap the ⋮ menu',
  a2: 'Top right of the screen. Or use the Install Ghost Cable button at the top of this page, if it shows.',
  a3t: 'Tap Add to Home screen, then Install',
  a3: 'On some phones the menu item is called Install app. Confirm with Install.',
  a4t: 'Open it from your apps',
  a4: 'Ghost Cable shows up on your home screen and in your app drawer, like any other app.',
  aTip: 'Using Samsung Internet? Tap the ☰ menu, then Add page to, then Home screen.',

  d1t: 'Open this page in Chrome or Edge',
  d1: 'Firefox cannot install websites as apps, so switch to Chrome or Edge for this step.',
  d2t: 'Click the install icon',
  d2: 'It sits at the right end of the address bar: a small screen with a down arrow. Or use the Install Ghost Cable button at the top of this page.',
  d3t: 'Click Install',
  d3: 'Ghost Cable opens in its own window and is added to your Start menu, taskbar or app shelf.',
  dTip: 'No install icon? In Chrome open ⋮ then Cast, save and share, then Install page as app. In Edge open ⋯ then Apps, then Install this site as an app.',

  m1: 'Needs macOS Sonoma or later. On an older Mac, use Chrome and follow the Windows steps instead.',
  m2t: 'Choose File, then Add to Dock',
  m2: 'Or click the Share button in the toolbar and choose Add to Dock.',
  m3t: 'Click Add',
  m3: 'Ghost Cable appears in your Dock and Launchpad and opens in its own window.',
  mTip: 'Prefer Chrome on Mac? Click the install icon at the right end of the address bar, then Install.',

  fq1: 'Does this replace my IPTV player?',
  fa1: 'No. The app is your Ghost Cable account: ordering, renewals, login details, receipts and support. Your channels still play in your IPTV player app or Desktop Telly, using the login details shown in your account.',
  fq2: 'Is it safe?',
  fa2: 'Yes. It is the same Ghost Cable website, saved to your device. It cannot see your other apps, files or photos, and no payment is ever taken inside it.',
  fq3: 'Where do I get the Downloader code?',
  fa3: 'The Downloader code is given to you when you purchase a plan, or you can use your own. That is why it is left blank on this page. Enter it in step 3 of the TV setup above.',
  fq4: 'How do I keep it up to date?',
  fa4: 'You do not have to. It loads the latest version every time you open it.',
  fq5: 'How do I remove it?',
  fa5: 'Remove it like any other app. On a phone, press and hold the icon and choose Remove or Uninstall. On a computer, open the app, click the ⋮ or ⋯ menu in its title bar and choose Uninstall. On a Mac, drag it out of the Dock and delete it from your Applications folder.',

  s1t: 'Install the Downloader app',
  s1: 'On your TV, search for Downloader (the orange icon by AFTVnews) in the Amazon Appstore or Google Play, then install it. It is free.',
  s2t: 'Let Downloader install apps',
  s2: 'Fire TV: go to Settings, My Fire TV, Developer options, Install unknown apps, and switch Downloader on. Android TV or Google TV: go to Settings, Apps, Security & restrictions, Unknown sources, and allow Downloader.',
  s2tip: 'No Developer options on your Fire TV? Go to Settings, My Fire TV, About, and click your device name 7 times. It appears straight away.',
  s3t: 'Enter your Downloader code',
  s3: 'Open Downloader, allow it access if it asks, then select the box on the Home screen. Type the Downloader code given to you at purchase, or your own, and press Go.',
  s4t: 'Install the player',
  s4: 'The download starts on its own. When it finishes, choose Install, then Done. Downloader may offer to delete the installer file: choose Delete to save space.',
  s5t: 'Open it and sign in',
  s5: 'Find the player with your apps. Sign in with the login details from your Ghost Cable account, and your channels and TV guide load in a minute or two.',

  tvFor: 'For {list} and {last}. Five steps with your remote, about five minutes start to finish.',
  givenOrOwn: 'Given at purchase or use your own',
  setupTv: 'Set up your TV',
  tvHead: 'Watch on your TV with the {code}',
  tvCode: 'Downloader code.',
  leftBlank: 'Left blank here. Your Downloader code is given to you when you purchase, or use your own.',
  yourCode: 'Your Downloader code',
  whenPurchase: 'When you purchase, a code is given to you. Or use your own.',
  needStep3: 'You need it for step 3. Type it into Downloader exactly as given, and keep it handy in case you set up another TV later.',
  getCode: 'Get my code',
  onlyAndroid:
    "Downloader only works on Android-based TVs. On a smart TV, iPhone, iPad or computer, install your IPTV player from that device's own app store.",
  use: 'Use',
  lookIcon: 'Look for this icon on your device once it is installed.',

  installed: 'Ghost Cable is installed. Find it with your apps.',
  installGC: 'Install Ghost Cable',
  copied: 'Link copied. Open it on the phone or computer you want the app on.',
  cantCopy: 'Could not copy. The link is {url}',
  usingApp: "You're using the Ghost Cable app",
  sendOther: 'Send to another device',
  showHow: 'Show me how',
  sendPhone: 'Send the link to my phone',
  setupFire: 'Set up a Fire TV or Android TV',

  getApp: 'Get the app',
  heroA: 'Ghost Cable, {rest}',
  heroB: 'right on your home screen.',
  heroP: "Install Ghost Cable as an app on your phone, tablet or computer in under a minute. It's free, needs no app store, and opens straight to your account.",
  inApp: "You're viewing this inside another app, which can't install websites. Open the ••• menu and choose Open in browser, then come back to this page.",
  nextTo: 'next to your other apps',
  pickDevice: 'Pick your device and follow the steps.',
  thisDevice: 'This device',
  goodToKnow: 'Good to know',
  before: 'Before you install',
  notCustomer: 'Not a customer yet?',
  pickPlan: 'Pick a plan, then install.',
  onceLive: 'Once your line is live, your login details and setup guide are waiting in the app.',
  seePlans: 'See plans',
};
